module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui tab top attached loading",
    attrs: {
      "id": "items-list-container"
    }
  }, [_c('div', {
    staticClass: "ui container",
    class: _vm.has_items ? "" : "shown",
    attrs: {
      "id": "empty-list"
    }
  }, [_c('h1', [_vm._v("there's nothing here :o")])]), _c('ul', _vm._l((_vm.items), function(item, id) {
    return _c('item-card', {
      attrs: {
        "item": item,
        "id": id,
        "db": _vm.db_items,
        "delete-lock": _vm.delete_lock
      }
    })
  })), _c('div', {
    staticClass: "button-clear"
  }), (_vm.uservalid) ? _c('button', {
    staticClass: "circular ui icon button massive primary",
    on: {
      "click": _vm.show_add
    }
  }, [_c('i', {
    staticClass: "icon plus"
  })]) : _vm._e(), _c('add-item', {
    attrs: {
      "id": "add-item",
      "db": _vm.db_items
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16978faa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemsList.vue
// module id = 51
// module chunks = 0